import React, { useState, useEffect } from "react";
import HeroSectionImage from "../assets/praias.jpg";
import Logo from "../assets/belleepoque_logo.png";

// Image URL (replace with your desired static image)
const staticImage = HeroSectionImage; // Use the first image or replace with your preferred one

const Carousel = () => {
  return (
    <div className="carousel-container relative overflow-hidden">
      <div className="carousel-inner relative h-screen w-full shadow-2xl">
        {/* Static Image */}
        <img
          src={staticImage}
          alt="Static Slide"
          className="w-full h-full object-cover"
        />
      </div>

      {/* Logo */}
      <div className="absolute inset-0 flex flex-col items-center justify-center z-20 mt-8">
        <img
          src={Logo} // Replace with your logo
          alt="Logo"
          className="w-96 h-auto animate-fadeIn"
        />
      </div>
    </div>
  );
};

export default Carousel;
